import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { ReceiptsListPage } from '../../../features/sales/receipts-list-page'
import { receiptSearchSchema } from '../../../features/sales/search'

export const Route = createFileRoute('/_app/receipts/')({
  validateSearch: receiptSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'sales.read'),
  component: ReceiptsListPage,
})
